module.exports = __webpack_public_path__ + "static/media/successHouse.acd47b4d.svg";